module.exports = __webpack_public_path__ + "static/q4_x-385e3382216f493275677189b9e01a3e.png";